import Products from 'merchandise-lib/constants/Product';
import { isApiName } from './purchaseMotionTypeGuards';

/**
 * Suite product mapping for signup URL and revenue tracking.
 * Maps CRM suite bundle API names to their signup string identifiers.
 */
const SUITE_SIGNUP_OVERRIDE_MAP = {
  [Products.CRM_SUITE_STARTER_BUNDLE]: 'crmsuitestarterbundle',
  [Products.CRM_SUITE_PROFESSIONAL_BUNDLE]: 'crmsuiteprofessionalbundle',
  [Products.CRM_SUITE_ENTERPRISE_BUNDLE]: 'crmsuiteenterprise'
};

/**
 * Checks if the given API name is a CRM suite bundle product.
 */
export const isSuiteProduct = apiName => {
  return Object.keys(SUITE_SIGNUP_OVERRIDE_MAP).includes(apiName);
};

/**
 * Gets the product identifier for signup URL and revenue tracking.
 * Returns a mapped value for suite products, otherwise returns the original API name.
 */
export const getNonMerchandiseIdProduct = apiName => {
  if (!isApiName(apiName)) {
    return apiName;
  }
  return SUITE_SIGNUP_OVERRIDE_MAP[apiName] || apiName;
};

/**
 * Converts a string to lowercase kebab-case.
 * Example: "MARKETING_HUB_STARTER" -> "marketing-hub-starter"
 */
const toKebabCase = source => {
  return source.toLowerCase().replace(/_/g, '-');
};

/**
 * Generates the dtbSource tracking parameter for DirectToBuy buttons.
 * Suite products include the product level in the source.
 * The tracking source is converted to lowercase kebab-case.
 *
 * Examples:
 * - Non-suite: "pricing-page|marketing-hub-starter"
 * - Suite: "pricing-page|crm-suite|suite|starter"
 */
export const getDtbSource = (trackingData, trackingSource, apiName) => {
  const kebabSource = toKebabCase(trackingSource);
  if (isSuiteProduct(apiName)) {
    const productLevel = apiName.replace('crm-suite-', '').replace('-bundle', '');
    return `${trackingData.app}|${kebabSource}|suite|${productLevel}`;
  }
  return `${trackingData.app}|${kebabSource}`;
};

/**
 * Gets the dttSource tracking parameter for DirectToTrial buttons.
 * Returns the tracking source from trackingData.
 */
export const getDttSource = trackingSource => {
  return trackingSource;
};

/**
 * Extracts the tracking source from TrackingData.
 * Uses source if available, otherwise falls back to uniqueId.
 */
export const getTrackingSourceFromTrackingData = trackingData => {
  return trackingData.source || trackingData.uniqueId || '';
};

/**
 * Extracts the sourceId from TrackingData for hubs_signup-cta generation.
 * Returns uniqueId or source as fallback.
 */
export const getSourceIdFromTrackingData = trackingData => {
  return trackingData.uniqueId || trackingData.source || '';
};